import { LogoutTemplate } from '@/templates/Logout'

const Logout = (): JSX.Element => {
  return <LogoutTemplate />
}

export default Logout
